import type { User } from '@/api/resources/auth'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface AuthState {
  token: string | null
  user: User | null
  expiresAt: string | null

  setAuth: (token: string, user: User, expiresAt: string | null) => void
  setUser: (user: User) => void
  clearAuth: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      expiresAt: null,

      setAuth: (token, user, expiresAt) => set({ token, user, expiresAt }),
      setUser: (user) => set({ user }),
      clearAuth: () => set({ token: null, user: null, expiresAt: null }),
    }),
    {
      name: 'junea-auth',
      partialize: (state) => ({
        token: state.token,
        user: state.user,
        expiresAt: state.expiresAt,
      }),
    },
  ),
)
